import React, { useEffect, useState } from 'react';
import { Modal } from '@els/els-react--modal';
import { Button } from '@els/els-react--button';
import PropTypes from 'prop-types';
import IdleHandling from '@Services/IdleHandling';
import moment from 'moment-timezone';

import './IdleWarningModal.scss';

const HEADING = 'Are you still there?';

function formatTimeLeft(milliseconds) {
  return moment.utc(moment.duration(milliseconds).as('milliseconds')).format('mm:ss');
}

function IdleWarningModal({ expiresAt }) {
  const [remaining, setRemaining] = useState(() => Math.max(expiresAt - Date.now(), 0));

  useEffect(() => {
    const interval = setInterval(() => {
      // Recompute from the absolute deadline so background-tab throttling cannot lengthen the countdown.
      const left = expiresAt - Date.now();
      if (left <= 0) {
        clearInterval(interval);
        setRemaining(0);
        IdleHandling.processSessionExpiry();
        return;
      }
      setRemaining(left);
    }, 1000);
    return () => clearInterval(interval);
  }, [expiresAt]);

  const continueSession = () => IdleHandling.continueSession();

  return (
    <Modal
      onClose={continueSession}
      label={HEADING}
      width="min(34rem, calc(100vw - 2rem))"
      className="idle-warning-modal"
      id="idle-warning"
      shouldPreventClickOverlayToClose>
      <div>
        <h4 className="u-els-margin-bottom">{HEADING}</h4>
        <div className="idle-warning-content">
          You have been inactive for a while. For privacy and security, your session will end in{' '}
          <b aria-hidden="true">{formatTimeLeft(remaining)}</b>.
        </div>
        <div className="u-els-margin-top idle-warning-secondary">This may result in unsaved data being lost.</div>
        <div className="u-els-margin-top-2x u-els-display-flex o-els-flex-layout--right">
          <Button data-e2e="idle-continue-working" onClick={continueSession}>
            Continue working
          </Button>
        </div>
      </div>
    </Modal>
  );
}

IdleWarningModal.propTypes = {
  expiresAt: PropTypes.number.isRequired,
};

export default IdleWarningModal;
